import React from "react";
import {makeStyles, Grid} from "@material-ui/core";
import TextFieldValidator from "../../../../LeaveApplication/component/Validator/TextFieldValidator";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginBottom: theme.spacing(1),
    },
    inputField: {
        height: 6,
    },
    cssLabel: {
        color: "#000",
        '&.Mui-focused': {
            color: '#000'
        }
    }
}));

export default function CustomTextField({label, name, values, handleChange, type, validators, readonly, space}) {
    const classes = useStyles();
    const fieldRequired = 'this field is required'

    return (
        <Grid item xs={space}>
            <div style={readonly ? {pointerEvents: 'none'} : {pointerEvents: 'auto'}}>
                <TextFieldValidator
                    fullWidth
                    type={type}
                    label={label}
                    id={name}
                    value={values}
                    onChange={handleChange}
                    inputProps={{
                        name: name,
                        id: name + '-native-disabled',
                    }}
                    className={classes.textField}
                    variant="outlined"
                    InputProps={{classes: {input: classes.inputField}}}
                    InputLabelProps={{
                        className: classes.cssLabel
                    }}
                    validators={validators}
                    errorMessages={[fieldRequired]}
                />
            </div>
        </Grid>
    );
}
